import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FC } from "react";
import { useHistory } from "react-router";

import {
  Button,
  DesignToken,
  RadiusToken,
  ShadowToken,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import { config } from "config/config";
import { isInIframe } from "helpers/app";
import { SettingsRoutes } from "routes/settings/constants";
import { withVar } from "themes/helpers";

export const CannedResponsesEmptyState: FC = () => {
  const history = useHistory();

  const handleAddNewClick = (): void => {
    if (isInIframe()) {
      window.open(`${config.appUrl}${SettingsRoutes.CannedResponses}`);
    } else {
      history.push(SettingsRoutes.CannedResponses);
    }
  };

  return (
    <Wrapper>
      <Text
        css={css`
          padding-bottom: ${withVar(SpacingToken.Spacing2)};
        `}
      >
        No canned responses.
      </Text>
      <Button kind="link" onClick={handleAddNewClick}>
        Create new
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  color: ${withVar(DesignToken.ContentBasicSecondary)};
  border-radius: var(${RadiusToken.Radius3});
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  box-shadow: ${withVar(ShadowToken.PopOver)};
  padding: ${withVar(SpacingToken.Spacing3)};
`;
